import { useSearch } from "@tanstack/react-router";
import { UploadIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/button";
import { FeatureGuard } from "@/features/auth/permissions/feature-guard";
import {
  DesignConfidenceCheckerModal,
  useUploadingPolicy,
} from "@/features/request/design-confidence-checker";
import { useIsMobileScreen } from "@/hooks/useIsMobileScreen";

import { UploadFilesModal } from "./upload-files-modal";

export function UploadAction() {
  const { requestId } = useSearch({ strict: false });
  const { isConfidenceChecker, isLoading } = useUploadingPolicy(requestId);

  if (isLoading) return null;

  if (isConfidenceChecker && requestId !== undefined) {
    return <ConfidenceCheckerUploadAction requestId={requestId} />;
  }

  return <UploadFilesModal />;
}

function ConfidenceCheckerUploadAction({ requestId }: { requestId: number }) {
  const isMobile = useIsMobileScreen();
  const [isCheckerOpen, setIsCheckerOpen] = useState(false);

  return (
    <FeatureGuard feature="my-files.files.upload">
      <Button onPress={() => setIsCheckerOpen(true)} variant="secondary">
        <UploadIcon />
        {isMobile ? "" : "Upload New File"}
      </Button>
      <DesignConfidenceCheckerModal
        isOpen={isCheckerOpen}
        onOpenChange={setIsCheckerOpen}
        requestId={requestId}
      />
    </FeatureGuard>
  );
}
